var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SalesPointsMap',{attrs:{"tenant":_vm.tenant,"defaultInformationContent":_vm.content.length ? _vm.content[0].contentBody : undefined,"defaultInformationTitle":_vm.content.length ? _vm.content[0].title : undefined}})}
var staticRenderFns = []

export { render, staticRenderFns }